"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6461],{

/***/ 26461:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ product_slider; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/medusa-react/dist/medusa-react.esm.js + 1 modules
var medusa_react_esm = __webpack_require__(12863);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./src/lib/data/index.ts
var lib_data = __webpack_require__(39594);
// EXTERNAL MODULE: ./src/lib/hooks/use-previews.tsx + 1 modules
var use_previews = __webpack_require__(42984);
// EXTERNAL MODULE: ./node_modules/react-slick/lib/index.js
var lib = __webpack_require__(46066);
// EXTERNAL MODULE: ./src/modules/products/components/product-preview/index.tsx + 1 modules
var product_preview = __webpack_require__(84874);
;// CONCATENATED MODULE: ./src/lib/util/product-sort-color.ts
var sortProductsByColor = function(products) {
    return products.sort(function(productA, productB) {
        var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
        if ((productA === null || productA === void 0 ? void 0 : (ref = productA.tags) === null || ref === void 0 ? void 0 : ref.find(function(tag) {
            return tag === "ptag_01H4G4MQN3Z2T3PBGEY3RTTYXM";
        })) && (productB === null || productB === void 0 ? void 0 : (ref1 = productB.tags) === null || ref1 === void 0 ? void 0 : ref1.find(function(tag) {
            return tag === "ptag_01H4G4MQN3Z2T3PBGEY3RTTYXM";
        }))) return 0;
        if ((productA === null || productA === void 0 ? void 0 : (ref2 = productA.tags) === null || ref2 === void 0 ? void 0 : ref2.find(function(tag) {
            return tag === "ptag_01H4G4MQN3Z2T3PBGEY3RTTYXM";
        })) && !(productB === null || productB === void 0 ? void 0 : (ref3 = productB.tags) === null || ref3 === void 0 ? void 0 : ref3.find(function(tag) {
            return tag === "ptag_01H4G4MQN3Z2T3PBGEY3RTTYXM";
        }))) return 1;
        if (!(productA === null || productA === void 0 ? void 0 : (ref4 = productA.tags) === null || ref4 === void 0 ? void 0 : ref4.find(function(tag) {
            return tag === "ptag_01H4G4MQN3Z2T3PBGEY3RTTYXM";
        })) && (productB === null || productB === void 0 ? void 0 : (ref5 = productB.tags) === null || ref5 === void 0 ? void 0 : ref5.find(function(tag) {
            return tag === "ptag_01H4G4MQN3Z2T3PBGEY3RTTYXM";
        }))) return -1;
        if (productA.title.match(/geel|zwart|rustiek|walnoot|ebony|naturel/i) === null || productB.title.match(/geel|zwart|rustiek|walnoot|ebony|naturel/i) === null) return 0;
        var ref11;
        var colorA = (ref11 = (ref8 = (ref7 = productA === null || productA === void 0 ? void 0 : (ref6 = productA.title) === null || ref6 === void 0 ? void 0 : ref6.toLowerCase()) === null || ref7 === void 0 ? void 0 : ref7.match(/geel|zwart|rustiek|walnoot|ebony|naturel/i)) === null || ref8 === void 0 ? void 0 : ref8[0]) !== null && ref11 !== void 0 ? ref11 : "naturel";
        var ref12;
        var colorB = (ref12 = (ref10 = productB === null || productB === void 0 ? void 0 : (ref9 = productB.title) === null || ref9 === void 0 ? void 0 : ref9.toLowerCase().match(/geel|zwart|rustiek|walnoot|ebony|naturel/i)) === null || ref10 === void 0 ? void 0 : ref10[0]) !== null && ref12 !== void 0 ? ref12 : "naturel";
        var colorValues = {
            naturel: 0,
            zwart: 1,
            walnoot: 2,
            rustiek: 3,
            ebony: 4,
            geel: 5
        };
        if (colorValues[colorA] < colorValues[colorB]) {
            return -1;
        } else if (colorValues[colorA] > colorValues[colorB]) {
            return 1;
        } else {
            return 0;
        }
    });
};
/* harmony default export */ var product_sort_color = (sortProductsByColor);

// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
;// CONCATENATED MODULE: ./src/modules/common/components/product-slider/index.tsx












var ProductSlider = function(param) {
    var item = param.item;
    var cart = (0,medusa_react_esm/* useCart */.jD1)().cart;
    var pathname = (0,router.useRouter)().pathname;
    var swiperElRef = (0,react.useRef)(null);
    var settings = {
        dots: false,
        arrows: false,
        infinite: true,
        speed: 500,
        slidesToShow: 4,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1024,
                settings: {
                    slidesToShow: 4,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 600,
                settings: {
                    slidesToShow: 2,
                    slidesToScroll: 1
                }
            },
            {
                breakpoint: 480,
                settings: {
                    slidesToShow: 1,
                    slidesToScroll: 1
                }
            }
        ]
    };
    var queryParams = (0,react.useMemo)(function() {
        var params = {};
        var ref;
        params.id = (ref = item === null || item === void 0 ? void 0 : item.products) !== null && ref !== void 0 ? ref : [];
        params.cart_id = cart === null || cart === void 0 ? void 0 : cart.id;
        return params;
    }, [
        cart
    ]);
    var ref = (0,es.useInfiniteQuery)([
        "pslider",
        queryParams,
        "v2"
    ], function(param) {
        var pageParam = param.pageParam;
        return (0,lib_data/* fetchProductsList */._q)({
            pageParam: pageParam,
            queryParams: queryParams
        });
    }, {
        getNextPageParam: function(lastPage) {
            return lastPage.nextPage;
        }
    }), data = ref.data, hasNextPage = ref.hasNextPage, fetchNextPage = ref.fetchNextPage, isLoading = ref.isLoading, isFetchingNextPage = ref.isFetchingNextPage;
    var previews = (0,use_previews/* default */.Z)({
        pages: data === null || data === void 0 ? void 0 : data.pages,
        region: cart === null || cart === void 0 ? void 0 : cart.region
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "prev-button rounded-full border border-brand p-3 text-brand hover:bg-brand hover:text-white w-[50px] h-[50px]",
                onClick: function(e) {
                    e.preventDefault();
                    if (swiperElRef.current) {
                        // @ts-ignore
                        swiperElRef.current.slickPrev();
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Previous Slide"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        className: "h-5 w-5 -rotate-180 transform",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M9 5l7 7-7 7",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2"
                        })
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                className: "w-[calc(100%-100px)]",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(lib/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    ref: swiperElRef
                }, settings), {
                    children: (pathname !== "/" ? product_sort_color(previews) : previews.sort(function(productA, productB) {
                        var ref, ref1, ref2, ref3, ref4;
                        var ref5;
                        var colorA = (ref5 = (ref2 = (ref1 = productA === null || productA === void 0 ? void 0 : (ref = productA.title) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === null || ref1 === void 0 ? void 0 : ref1.match(/geel|zwart|rustiek|walnoot|ebony|naturel/i)) === null || ref2 === void 0 ? void 0 : ref2[0]) !== null && ref5 !== void 0 ? ref5 : "naturel";
                        var ref6;
                        var colorB = (ref6 = (ref4 = productB === null || productB === void 0 ? void 0 : (ref3 = productB.title) === null || ref3 === void 0 ? void 0 : ref3.toLowerCase().match(/geel|zwart|rustiek|walnoot|ebony|naturel/i)) === null || ref4 === void 0 ? void 0 : ref4[0]) !== null && ref6 !== void 0 ? ref6 : "naturel";
                        var colorValues = {
                            naturel: 3,
                            zwart: 2,
                            walnoot: 1,
                            rustiek: 0
                        };
                        if (colorValues[colorA] < colorValues[colorB]) {
                            return -1;
                        } else if (colorValues[colorA] > colorValues[colorB]) {
                            return 1;
                        } else {
                            return 0;
                        }
                    })).map(function(p, i) {
                        return /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                            className: "p-4",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(product_preview/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, p), {
                                doubleColl: false
                            }))
                        }, "swipe-".concat(i));
                    })
                }))
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("button", {
                className: "next-button rounded-full border border-brand p-3 text-brand hover:bg-brand hover:text-white w-[50px] h-[50px]",
                onClick: function(e) {
                    e.preventDefault();
                    if (swiperElRef.current) {
                        // @ts-ignore
                        swiperElRef.current.slickNext();
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("span", {
                        className: "sr-only",
                        children: "Next Slide"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("svg", {
                        className: "h-5 w-5",
                        fill: "none",
                        stroke: "currentColor",
                        viewBox: "0 0 24 24",
                        xmlns: "http://www.w3.org/2000/svg",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                            d: "M9 5l7 7-7 7",
                            "stroke-linecap": "round",
                            "stroke-linejoin": "round",
                            "stroke-width": "2"
                        })
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ var product_slider = (ProductSlider);


/***/ })

}]);